import React from "react";
import { useTranslation } from "react-i18next";
import UploadAlternativeData from "./UploadAlternativeData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataAlternativeScreen = () => {
  debugLogPages(':: ImportDataAlternativeScreen'); 

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataAlternative" />
      <div className="d-flex justify-content-center page-title">{t("admin.importdata.alternative.title")}</div>
      <hr className="line-hr" />

      <div>
        <UploadAlternativeData />
      </div>
    </>
  );
};

export default ImportDataAlternativeScreen;
